module.exports = __webpack_public_path__ + "img/_Middle-Semi-Elliptical-Attachment-R.2d31e9a1.jpg";